import { Component } from '@angular/core';
import {
  AtlasBannerService,
  AtlasBannerRef,
} from '@wellsky/atlas-ui/banners';
import {
  BannerDemoT1Component,
  BannerDemoT2Component,
  BannerDemoT3Component,
  BannerDemoT4Component,
} from 'app/components/banners/develop/components/banner-demo-components';
import {
  PrismLanguages,
  ExampleTemplate,
} from '@shared/models';
import {
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { EXAMPLE } from 'app/shell/constants/example';

@Component({
  selector: 'dls-banner-example',
  templateUrl: './banner-example.component.html',
  styleUrls: ['./banner-example.component.scss']
})
export class BannerExampleComponent {
  bannerWithSupportingIconExample: ExampleTemplate;
  bannerWithoutSupportingIconExample: ExampleTemplate;
  bannerDynamicDataExample: ExampleTemplate;
  bannerShowCloseExample: ExampleTemplate;
  atlasBannerRef: AtlasBannerRef<BannerExampleComponent>;
  bannerForm: FormGroup;

  constructor(private bannerService: AtlasBannerService) {
    // Banner with supporting icon
    this.bannerWithSupportingIconExample = EXAMPLE.BANNER_WITH_SUPPORTING_ICON;

    // Banner with supporting icon
    this.bannerWithoutSupportingIconExample = EXAMPLE.BANNER_WITHOUT_SUPPORTING_ICON;

    // Passing Dynamic Data
    this.bannerDynamicDataExample = EXAMPLE.DYNAMIC_DATA;

    // Show and close programmatically
    this.bannerShowCloseExample = EXAMPLE.SHOW_CLOSE_PROGRAMMATICALLY;

    this.bannerForm = new FormGroup({
      content: new FormControl('', Validators.required),
      imageURL: new FormControl('', Validators.required),
      primaryAction: new FormControl('', Validators.required),
      secondaryAction: new FormControl('', Validators.required)
    });
  }

  /**
   * Open Banner Template 1 with suppporting icon
   */
  openTemplate1(): void {
    // To check whether banner is already opened or not. If false then open Banner.
    if (!this.bannerService.isBannerLoaded) {
      this.atlasBannerRef = this.bannerService.open(BannerDemoT1Component);
    }

    /**
     * Subscription for afterClosed
     */
    this.atlasBannerRef.afterClosed.subscribe(() => {
      // user can perform action after banner is closed
    });
  }

  /**
   * Open Banner Template 2 without supporting icon
   */
  openTemplate2(): void {
    // To check whether banner is already opened or not. If false then open Banner.
    if (!this.bannerService.isBannerLoaded) {
      this.atlasBannerRef = this.bannerService.open(BannerDemoT2Component);
    }

    /**
     * Subscription for afterClosed
     */
    this.atlasBannerRef.afterClosed.subscribe(() => {
      // user can perform action after banner is closed
    });
  }

  // Open Dynamic Data Template
  openTemplate3(): void {
    // To check whether banner is already opened or not. If false then open Banner.
    if (!this.bannerService.isBannerLoaded) {
      this.atlasBannerRef = this.bannerService.open(BannerDemoT3Component,
        {
          data: {
            content: this.bannerForm.controls['content'].value,
            imageURL: this.bannerForm.controls['imageURL'].value,
            primaryAction: this.bannerForm.controls['primaryAction'].value,
            secondaryAction: this.bannerForm.controls['secondaryAction'].value
          }
        }
      );
    }
  }

  openTemplate4(): void {
    // To check whether banner is already opened or not. If false then open Banner.
    if (!this.bannerService.isBannerLoaded) {
      this.atlasBannerRef = this.bannerService.open(BannerDemoT4Component);
    }

    /**
     * Subscription for afterClosed
     */
    this.atlasBannerRef.afterClosed.subscribe(() => {
      // user can perform action after banner is closed
    });
  }

  onBannerClose(): void {
    this.atlasBannerRef.close();
  }

}
